import axios from "axios";
import Cookie from "js-cookie";
import { mutate, unstable_serialize } from "swr";
import { API_URL } from "utils/const";
import ATTRACTION_QUERY from "queries/attraction";
import RESORT_QUERY from "queries/resort";
import PARK_QUERY from "queries/park";

export default async function saveEdit(values, setSubmitting, item, setOpen) {
  const token = Cookie.get("token");
  axios.defaults.headers.common.Authorization = `Bearer ${token}`;

  const fileUploadHeader = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };

  const formattedValues = {};
  let type = item.__typename;

  if (item.__typename === "Parks") {
    formattedValues.Name = values.parkName;

    const lands = [];

    values?.lands?.forEach((land) => {
      if (!land?.Name) {
        return false;
      }

      lands.push({
        Name: land.Name,
        Content: land.Content || "",
        Attractions: land?.Attractions?.filter(
          (attraction) => !attraction?.id?.startsWith("--")
        )?.map((attraction) => attraction.id),
      });
    });

    formattedValues.Lands = lands;
  }

  if (item.__typename === "Attraction") {
    type = "attractions";
    formattedValues.Name = values.attractionName;
    formattedValues.Type = values.attractionType || "OTHER";
  }

  if (item.__typename === "Resort") {
    type = "resorts";
    formattedValues.Name = values.resortName;
  }

  if (values.latitude !== undefined && values.longitude !== undefined) {
    formattedValues.Location = {
      Latitude: values.latitude || null,
      Longitude: values.longitude || null,
    };
  }

  if (Array.isArray(values.attributes)) {
    const attributes = values.attributes.map((attribute) => ({
      ValueType: attribute.ValueType,
      Value: attribute.Value || "",
    }));

    formattedValues.Attribute = attributes;
  }

  if (typeof values?.description !== "undefined") {
    formattedValues.Description = values.description;
  }

  // Photos need to be uploaded on their own
  if (values.mainImage instanceof File) {
    const formData = new FormData();
    formData.append("files", values.mainImage);
    formData.append("ref", item.__typename);
    formData.append("refId", item.id);
    formData.append("field", "MainPhoto");
    await axios.post(`${API_URL}/upload`, formData, fileUploadHeader);
  }

  await axios.put(`${API_URL}/${type}/${item.id}`, formattedValues);

  // update cache
  if (type === "attractions") {
    mutate(unstable_serialize([ATTRACTION_QUERY, { slug: item.Slug }]));
  }

  if (type === "resorts") {
    mutate(unstable_serialize([RESORT_QUERY, { slug: item.Slug }]));
  }

  if (type === "Parks") {
    mutate(unstable_serialize([PARK_QUERY, { slug: item.Slug }]));
  }

  if (typeof setOpen === "function") {
    setOpen(false);
  }

  setSubmitting(false);
}
